<template>
  <div class="reflection-info">
    <v-icon
      v-if="template"
      class="reflection-icon material-icons"
      size="24"
      :color="template.color"
    >
      {{ template.icon }}
    </v-icon>
    <img
      v-else
      class="reflection-icon"
      src="../../assets/icons/ico-reflection.svg"
    >
    <span>
      {{ title }}
    </span>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { types } from '../../store/templates';

export default {
  name: 'ReflectionInfo',
  props: {
    title: {
      type: String,
      required: true,
    },
    templateId: {
      type: String,
      required: false,
      default: undefined,
    },
  },
  computed: {
    ...mapGetters({
      allTemplates: types.getters.templates,
    }),
    template() {
      if (!this.templateId || this.templateId === 'empty') {
        return undefined;
      }

      return this.allTemplates.find(t => t.id === this.templateId);
    },
  },
};
</script>

<style scoped>
.reflection-info {
  display: flex;
  align-items: center;
  min-width: 0;
  flex-shrink: 1;
}

.reflection-icon {
  margin-right: 16px;
  width: 28px;
}

span {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
</style>
